import * as React from "react";
import { useRef, useState } from "react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";

interface TooltipIfTruncatedProps {
  text: string;
  className?: string;
  side?: "top" | "right" | "bottom" | "left";
}

export const TooltipIfTruncated: React.FC<TooltipIfTruncatedProps> = ({
  text,
  className,
  side = "right",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (textRef.current) {
      const isTruncated = textRef.current.scrollWidth > textRef.current.clientWidth;
      if (isTruncated) {
        setIsOpen(true);
      }
    }
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <Tooltip open={isOpen}>
      <TooltipTrigger asChild>
        <span
          className="block min-w-0 flex-1 cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div ref={textRef} className={cn("truncate", className)}>
            {text}
          </div>
        </span>
      </TooltipTrigger>
      <TooltipContent side={side}>
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  );
};
